namespace GeniuzPOS.AdvPromo {
    export class PsAdvPromoItem6ExemptColumns {
        static columnsKey = 'AdvPromo.PsAdvPromoItem6Exempt';
    }
}
